import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import type { ImportTargetField } from './fuzzyColumnMatch';

export async function downloadImportTemplate(
    targetFields: Array<Pick<ImportTargetField, 'label'>>,
    filename = 'inventory-import-template.xlsx',
): Promise<void> {
    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet('Import');
    const headers = targetFields.map((f) => f.label);
    const headerRow = ws.getRow(1);
    headerRow.values = headers;
    headerRow.font = { bold: true };
    headers.forEach((_, i) => {
        ws.getColumn(i + 1).width = Math.max(14, Math.min(28, headers[i].length + 4));
    });
    const buffer = await wb.xlsx.writeBuffer();
    saveAs(
        new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }),
        filename,
    );
}
